import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-579eab6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " MaatComputers vervaardigt computers geheel naar wens van de klant. Voor ieder type gebruiker kan een computer worden samengesteld. Van kantoorwerk tot het spelen van veeleisende spelletjes, alles is mogelijk! ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Bij het reviseren van een computer wordt kapotte of verouderde hardware vervangen. Indien nodig, wordt ook het besturingssysteem vervangen. Het reviseren van een computer is meestal goedkoper dan het aanschaffen van een nieuwe computer. ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Computers worden opgeschoond door virussen, reclame en overige overbodige software te verwijderen. Een schone computer start sneller op en kan taken sneller uitvoeren. Daarnaast wordt koelpasta vervangen en worden koelelementen schoongemaakt. ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/contact" }, "contact", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_layout = _resolveComponent("header-layout")!
  const _component_page_button = _resolveComponent("page-button")!
  const _component_triple_block = _resolveComponent("triple-block")!
  const _component_notice_alert = _resolveComponent("notice-alert")!
  const _component_single_block = _resolveComponent("single-block")!
  const _component_footer_layout = _resolveComponent("footer-layout")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_header_layout, {
      title: "Werkzaamheden",
      displaySearchForm: false
    }),
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_triple_block, null, {
          default: _withCtx(() => [
            _createVNode(_component_page_button, {
              title: "Vervaardiging",
              path: "/werkzaamheden/vervaardiging"
            }),
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_triple_block, null, {
          default: _withCtx(() => [
            _createVNode(_component_page_button, {
              title: "Revisie",
              path: "/werkzaamheden/revisie"
            }),
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_triple_block, null, {
          default: _withCtx(() => [
            _createVNode(_component_page_button, {
              title: "Onderhoud",
              path: "/werkzaamheden/onderhoud"
            }),
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_single_block, null, {
          default: _withCtx(() => [
            _createVNode(_component_notice_alert, null, {
              default: _withCtx(() => [
                _createTextVNode(" MaatComputers levert ook laptops, beeldschermen, aansluitservices, netwerkservices en nog veel meer. Bij twijfel over een werkzaamheid, neemt u "),
                _hoisted_5,
                _createTextVNode(" op met MaatComputers. ")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_footer_layout)
  ], 64))
}